import { render, staticRenderFns } from "./allReturn.vue?vue&type=template&id=4f1a81e6"
import script from "./allReturn.vue?vue&type=script&lang=js"
export * from "./allReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports